<template>
  <icon-component v-bind="$props">
    <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M75.552 36.043H58.72V17.899a2.96 2.96 0 0 0-2.965-2.966H35.54a2.959 2.959 0 0 0-2.965 2.966v28.597h-16.81a2.96 2.96 0 0 0-2.966 2.965V73.92a2.959 2.959 0 0 0 2.965 2.965h45.408v-7.413h-40.96V53.92H39.99V22.347h11.318v21.12h19.797V59.52h7.413V39.008a2.959 2.959 0 0 0-2.965-2.965Z"
        fill="currentColor"
      />
      <path d="M82.614 65.258H66.923V80.95h15.69v-15.69Z" fill="currentColor" />
    </svg>
  </icon-component>
</template>

<script>
  import IconComponent from './IconComponent.vue';

  export default {
    components: {
      IconComponent,
    },
    extends: IconComponent,
  };
</script>
